import { createContext, useContext } from 'react';
import { BimTreeNode } from 'Data/interfaces/BimViewer/IBimViewerPort';

/** Visível · oculto · parcial (alguém escondeu parte do que está aí dentro). */
export type NodeVisibility = 'visible' | 'hidden' | 'partial';

export interface INodeVisibility {
  visibilityOf(node: BimTreeNode): NodeVisibility;
  toggleVisibility(node: BimTreeNode): void;
}

/**
 * A visibilidade chega ao título por CONTEXTO, não por prop, e a razão é
 * performance: como prop, ela ficaria assada dentro do elemento criado em
 * `toDataNode`, e cada clique no olho obrigaria a remontar o `treeData` inteiro
 * — que o antd então reprocessa (achatar, reindexar) do começo. Pelo contexto,
 * o `treeData` só muda quando a ESTRUTURA muda, e um toggle re-renderiza apenas
 * as linhas montadas, que a virtualização já limita ao viewport.
 */
const NodeVisibilityContext = createContext<INodeVisibility>({
  visibilityOf: () => 'visible',
  toggleVisibility: () => undefined,
});

export const NodeVisibilityProvider = NodeVisibilityContext.Provider;

export const useNodeVisibility = (): INodeVisibility => useContext(NodeVisibilityContext);
